import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PlanManagement.css';
import { COLORS } from '../styles/colors';
import { getMyPlan } from '../utils/api';

const PlanManagement = () => {
  const [showCompanyCode, setShowCompanyCode] = useState(false);
  const [planData, setPlanData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [daysLeft, setDaysLeft] = useState(0);
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchPlanData = async () => {
      try {
        setLoading(true);
        const response = await getMyPlan();
        setPlanData(response.data);
        
        // 남은 일수 계산
        if (response.data && response.data.end_date) {
          const endDate = new Date(response.data.end_date);
          const today = new Date();
          const diffTime = Math.abs(endDate - today);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          setDaysLeft(diffDays);
        }
        
        setLoading(false);
      } catch (err) {
        console.error('플랜 정보 로딩 오류:', err);
        setError('플랜 정보를 불러오는 중 오류가 발생했습니다.');
        setLoading(false);
      }
    };
    
    fetchPlanData();
  }, []);
  
  // 날짜 포맷 함수 (YYYY. MM. DD. 형식으로 변환)
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}. ${month}. ${day}.`;
  };
  
  const handleExtend = () => {
    console.log('플랜 연장 요청');
    // 구독 연장 페이지로 이동
    navigate('/dashboard/plan-extend');
  };
  
  if (loading) {
    return <div className="planManagementContainer">로딩 중...</div>;
  }
  
  if (error) {
    return <div className="planManagementContainer">
      <div className="errorMessage">{error}</div>
      <button 
        className="retryButton"
        onClick={() => window.location.reload()}
      >
        다시 시도
      </button>
    </div>;
  }
  
  return (
    <div className="planManagementContainer">
      <h1 className="pageTitle">나의 플랜</h1>
      
      <div className="planInfoSection">
        <div className="planStatus">
          <span className="planName">{'TapGo Plus'}</span> 플랜이 
          <span className="planExpiry"> {formatDate(planData?.end_date)}</span>에 종료됩니다. 
          (<span className="daysLeft">{daysLeft}</span>일 남음)
        </div>
        
        <div className="buttonContainer">
          <button 
            className="subscribeButton"
            onClick={handleExtend}
            style={{ backgroundColor: COLORS?.subscribeButtonBg || 'rgba(255, 94, 7, 0.15)', color: 'black' }}
          >
            <span className="buttonPrefix smallText">출퇴근 관리를 쉽게!</span>
            <span className="buttonText">TapGo Plus 구독연장하기</span>
          </button>
        </div>
      </div>
      
      <div className="companyCodeSection">
        <h2 className="sectionTitle boldText">나의 회사코드</h2>
        
        <div className="codeDisplayBox">
          <div className="codeValue">
            {showCompanyCode ? (planData?.company_code || "코드 없음") : "*".repeat(planData?.company_code?.length || 10)}
          </div>
          <button 
            className="viewCodeButton"
            onClick={() => setShowCompanyCode(!showCompanyCode)}
            aria-label={showCompanyCode ? "코드 숨기기" : "코드 보기"}
          >
            <svg 
              viewBox="0 0 24 24" 
              fill="none" 
              width="24" 
              height="24" 
              stroke="currentColor" 
              strokeWidth="2"
              className="eyeIcon"
            >
              {showCompanyCode ? (
                // 열린 눈 아이콘
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/>
              ) : (
                // 닫힌 눈 아이콘
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/>
              )}
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanManagement; 